export default __webpack_public_path__ + "static/media/poppy_tile-mobile.png.webp";